<template>
  <div>
      <div class="form-container ou-donation-form">
          <div class="holder jsu-forms">
              <PaymentForm class="form-horizontal">
              <h4>Choose an amount</h4>
                <!-- <h4 class="chooseamoun__title">Choose an amount</h4> -->
                  <FormSection title="">
                      <div>
                          <AmountSelector amountText="Other Amount"/>                    
                          <ErrorLabel field="amount" />
                      </div>
                  </FormSection> 
                  <br>
         
                   
                   <FormSection v-if="form.amount">
                    <div class="fee-info-container">
			By covering the transaction fees, you are completely eliminating JSU Atlanta payment processing overhead and enabling them to receive 100% of your intended donation.
			<br/>
			<div class="flex">
				<input type="checkbox" id="cover" :value="form.handleProcessing" @change="setValue('handleProcessing', $event.target.checked)"/>
				<FormLabel for="cover">
          Yes, include a transaction fee of 
				  <MoneyFormat class="amount" :value="parseInt(form.amount) * feePercent / 100" :currencyCode="form.currency" />
				  so that 100% of your donation goes to JSU Atlanta
        </FormLabel>
			</div>
		</div>

                  </FormSection>
                  <br> 
                  <FormSection title="Designation">
                      <FormRow>
                          <FormLabel class="control-label">
                            I'd like to designate this donation for a specific chapter or JSU club
                        </FormLabel>
                      </FormRow>									
                      <FormRow>
                        <FormInput type="text" class="width-full" field="custom.Notes" />
                      </FormRow> 
                </FormSection>                    
                
                <FormSection title="Make it monthly!">
                  <div class="frequency">
                    <PaymentOptions addMonthly monthlyText="Yes, Count me in!" oneTimeText="No, Donate once"/>
                  </div>
                </FormSection>                   
                  <FormSection title="Personal Information">
                      <FormRow inline>      
                          <FormCol field="title" :flex="1" />
                          <FormCol field="firstName" :flex="2" />
                          <FormCol field="lastName" :flex="2" />
                      </FormRow>
                      <FormRow inline>
                          <FormCol field="email" />
                          <FormCol field="phone" />
                      </FormRow> 
                      <FormRow inline>
              <Consent privacy="https://jsu.org/privacy-policy/"/>
            </FormRow>                                           
                      <DonorAddress />
                      <!-- <br />
            <FormRow>
              <NewsletterSubscribe
                text="Click here to stay updated on the JSU campaign"/>
            </FormRow> -->
                  </FormSection>
                  <FormSection title="Payment Information" last>
            <div class="payment-info">
              <FormRow>
                <PaymentType cc_text="Credit Card" check_text="Check" />
              </FormRow>
              <FormRow inline>
                <FormCol
                  class="doublepay"
                  field="card"
                  :showLabel="false"
                  check_text=""
                />
              </FormRow>
              <FormRow
                v-if="form.gateway === 'check'"
                style="justify-content: center"
                class="checktext"
              >
                <div>
                  Please mail your check to the following address:
                  <p style="text-align: center">
                    <strong
                      >JSU Atlanta<br />
                      311 Briarvista Way,<br />
                      Atlanta GA 30329</strong
                    >
                  </p>
                </div>
              </FormRow>
            </div>
          </FormSection>
                  <PaymentButton amountFirst/>
              </PaymentForm>
          </div>
      </div>
  </div>
  </template>
  
  <script lang="ts">
  import { computed, defineComponent, onMounted, ref, watch} from 'vue';
  import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

  export default defineComponent({
    props: {
      subCampaign: String,
    },    setup() {
      const feePercent = 2.5
      const { getValue, settings, setValue, form } = usePaymentForm();
    
      const params = queryParams();

      if (params.designation) {
      //@ts-ignore
      switch (params.designation) {
        case "Atlanta+Region":
          setValue("applications.0.department", "NCSY_Atlanta");
          break;
        case "Atlantic+Seaboard":
          setValue("applications.0.department", "NCSY_AtlanticSeaboard");
          break;
        case "Canada":
          setValue("applications.0.department", "NCSY_Canada");
          break;
        case "Central+East":
          setValue("applications.0.department", "NCSY_CentralEast");
          break;
        case "Midwest+NCSY":
          setValue("applications.0.department", "NCSY_Midwest");
          break;
        case "NCSY":
          setValue("applications.0.department", "NCSY");
          break;
        case "NY+NJ":
          setValue("applications.0.department", "NCSY_Tristate");
          break;
        case "NCSY_Tristate":
          setValue("applications.0.department", "NCSY_Tristate");
          break;
        case "NCSY_NewYork":
          setValue("applications.0.department", "NCSY_Tristate");
          break;
        case "Northeast":
          setValue("applications.0.department", "NCSY_NewEngland");
          break;
        case "Oregon+NCSY":
          setValue("applications.0.department", "NCSY_Portland");
          break;
        case "Southern+NCSY":
          setValue("applications.0.department", "NCSY_Southern");
          break;
        case "Southwest":
          setValue("applications.0.department", "NCSY_Southwest");
          break;
        case "West+Coast+NCSY":
          setValue("applications.0.department", "NCSY_WestCoast");
          break;
      }
    }

      if (params.source == 'telemarketing') {
        setValue('applications.0.campaign', 'ADM Emergency JSU')
        setValue('applications.0.department', 'NCSY')
      }

      return {
        feePercent,
        form,
      getValue,
      settings,
      setValue,
              }
    },
  })
  </script>
  <style scoped lang="scss">
  .card-img {
    display: flex;
    img {
      height: 23px;
    }
  }
  
  h3.subtitle{
    text-align: center;
      color: #561045;
      font-size: 22px;
      margin-top: 0px;
      margin-bottom: 35px;  
  }
  ::v-deep h2{
    font-family: 'Poppins';
font-style: normal;
font-weight: 600;
font-size: 30px;
line-height: 36px;
margin-bottom: 20px;
color: #005AE3;
  }
  ::v-deep .styled-radio--ou-donation.styled-radio {
  
  .radio-part{
    min-width: 25%;
    flex: 1;
    padding-right: 10px;
    padding-left: 0;
    max-width:25%;
    margin-bottom: 16px;
    &:nth-child(6n){
      padding-right: 10px;
    }
    &:nth-child(9){
      min-width: 64%;
      max-width: 64%;
      @media (max-width: 500px) {
        min-width: 92%;
      max-width: 92%;
      }
    }

    label{
    background: #2773e7;
    border-radius: 8px;
    font-style: normal;
    border: 1px solid #5d6165;
    font-weight: 500;
    font-size: 18px;
    line-height: 26px;
    color: black;
    }

&:nth-child(-n+4) {
  label{
  background: #DEEAFB;
  }
}
&:nth-child(n+5):nth-child(-n+8) {
    label{
  background:#7baaec;
    }
}


  }

    .money_format.label-amount {
    width: 100%;
    position: relative;
    }
  }
  ::v-deep .styled-radio--ou-donation.styled-radio input[type='radio']:checked + label {
    background: #005AE3 !important;
    color: white !important;
}
  ::v-deep .form-container.ou-donation-form{
   box-shadow: none;
   padding: 0px;
   margin: 0px;
   max-width: 100%;
}
  ::v-deep .styled-radio-container.styled-radio-container--ou-donation.row .radio-part{
    min-width: 45%;
    max-width: 45%;
}
  ::v-deep .styled-radio-container--ou-donation.styled-radio-container label{
    background: #FFFFFF;
border: 1px solid #DCE7F8;
box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
border-radius: 24px;
}
  ::v-deep .styled-radio-container--ou-donation.styled-radio-container input[type="radio"]:checked + label,
  ::v-deep #donate-widget-form-submit{
    background: #005AE3;
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
border-radius: 24px;
font-weight: 600 !important;
    color: white;
}

  ::v-deep .styled-radio--ou-donation .amount_other__wrapper,
{
  margin-bottom: 10px;
    margin-right: 0;
    margin-bottom: 15px;

    overflow: hidden;
    border: 1px solid black;
    border-radius: 4px;
    padding-left: 5px;
    flex: 1;
    overflow: hidden;
    min-width: 34%;
    max-width: 100%;
    line-height: 1;
    @media (max-width: 500px) {
      min-width: 45%;
    max-width: 45%;
    }
    input#amount_other_field{
      height: 46px;
      color: black;
      font-weight: 500;
    font-size: 18px;
    line-height: 26px;
    }
}

.fee-info-container {
  background: #f2f5f8;
  padding: 15px;
  border-radius: 4px;
  margin-top: 15px;
  line-height: 1.4;
  font-size: 13px;

  input[type='checkbox'] {
  margin-right: 7px;
}
.amount {
  font-weight: bold;
  display: inline-block;
}
.inline-block {
  display: inline-block;
}
.edit {
  color: #0075ff;
  cursor: pointer;
  margin-left: auto;
  text-decoration: underline;
}
::v-deep label {
  font-size: 13px;
}
.flex {
  display: flex;
  margin-top: 10px;

  input {
    margin-top: 4px;
  }
}
}

h4.chooseamoun__title{
  color: var(--primary-dark-blue, #000453);
  font-family: 'Poppins';
font-size: 20px;
font-style: normal;
font-weight: 600;
line-height: 30px; /* 150% */
margin: 0px 0px 20px;
}


h4{
      color: #000453;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
    margin-bottom: 12px;
    opacity: .7;

        @media (min-width: 720px) {
        color: #000453;
        font-family: Poppins;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 30px;
        margin-bottom: 12px;
        opacity: .7;
        }
}
  </style>
  
  